<!--
    描述：支付流水
    时间：2020/11/3
    Created by zl
-->
<template>
	<div class="h100 pay-money">
	  <filter-layout
		@search="searchResult"
		@reset="reset"
		hasMore
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="流水号：" prop="bizOrderNo">
			  <el-input
				v-model="searchForm.bizOrderNo"
				placeholder="请输入流水号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="订单来源：" prop="sysNo">
			  <el-select
				v-model="searchForm.sysNo"
				placeholder="请选择订单来源"
				size="small"
			  >
				<el-option
				  v-for="item in goodsType"
				  :key="'goods' + item.value"
				  :label="item.sname"
				  :value="item.value"
				></el-option>
			  </el-select>
			</el-form-item>
			  <el-form-item label="支付状态：" prop="status">
				  <el-select v-model="searchForm.status" placeholder="请选择支付状态" size="small">
					  <el-option value="0" label="待支付"></el-option>
					  <el-option value="1" label="支付成功"></el-option>
					  <el-option value="2" label="支付失败"></el-option>
					  <el-option value="3" label="订单取消"></el-option>
					  <el-option value="4" label="已退款"></el-option>
				  </el-select>
			  </el-form-item>
			  <el-form-item label="支付方式：" prop="payType">
				  <el-select
					  v-model="searchForm.payType"
					  placeholder="请选择支付方式"
					  size="small"
				  >
					  <el-option
						  v-for="item in payType"
						  :key="'payType' + item.value"
						  :value="item.value"
						  :label="item.sname"
					  ></el-option>
				  </el-select>
			  </el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm">
			  <el-form-item label="会员ID：" prop="payerId">
				  <el-input
					  v-model="searchForm.payerId"
					  placeholder="请输入会员ID"
					  size="small"
				  ></el-input>
			  </el-form-item>
			<el-form-item label="订单金额：" prop="minAmount">
			  <el-col :span="11">
				<el-input
				  v-model="searchForm.minAmount"
				  size="small"
				  type="number"
				  min="0"
				  placeholder="请输入"
				></el-input>
			  </el-col>
			  <el-col :span="2" class="text-center">~</el-col>
			  <el-col :span="11">
				<el-input
				  v-model="searchForm.maxAmount"
				  size="small"
				  type="number"
				  min="0"
				  placeholder="请输入"
				></el-input>
			  </el-col>
			</el-form-item>
			<el-form-item label="订单时间：" prop="orderStarDate">
			  <div style="display: flex">
				<el-date-picker
				  v-model="searchForm.orderStarDate"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="startDatePicker"
				>
				</el-date-picker>

				<span class="text-center pd5">~</span>

				<el-date-picker
				  v-model="searchForm.orderEndDate"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="endDatePicker"
				>
				</el-date-picker>
			  </div>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">

			  <div class="title">
				合计支付：<span class="blue">{{ tablePage.total }}</span> 笔
			  </div>
			  <div class="toolbar">
				<!-- <el-button type="primary"
					   class="btn-blue ml10"
					   size="small"
					   @click="changeState">
				  筛选
				  <i v-if="searchToggle"
					 class="el-icon-caret-bottom ml5"></i>
				  <i v-else
					 class="el-icon-caret-top ml5"></i>
				</el-button> -->
				<el-button
				  type="primary"
				  class="btn-blue ml10"
				  icon="el-icon-refresh"
				  @click="reset"
				  size="small"
				></el-button>

			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow" ref="table">
			  <vxe-table
				ref="xTable"
				:data="tableData"
				highlight-current-row
				highlight-hover-row
				border
				size="small"
				height="100%"
				auto-resize
				show-overflow="tooltip"
				show-header-overflow="tooltip">
				<vxe-table-column
				  type="seq"
				  width="70px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bizOrderNo"
				  title="支付流水号"
				  header-align="center"
				  min-width="120px"
				></vxe-table-column>
				<vxe-table-column
				  field="amount"
				  title="订单金额"
				  header-align="center"
				  align="right"
				  min-width="100px">
				  <template v-slot="{ row }">
					{{ row.amount.toFixed(2) }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="serviceFee"
				  title="手续费"
				  min-width="120px"
				  header-align="center"
				  align="right"
				>
				  <template v-slot="{ row }">
					{{ row.serviceFee.toFixed(2) }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="payerId"
				  title="会员Id"
				  min-width="180px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="createDate"
				  title="订单时间"
				  sortable
				  min-width="160px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="payType"
				  title="支付方式"
				  width="8%"
				  align="center"
				>
				  <template v-slot="{ row }">
					{{ dealType(row.payType, "pay") }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="sysNo"
				  title="订单来源"
				  min-width="120px"
				  align="center"
				>
				  <template v-slot="{ row }">
					{{ dealType(row.sysNo, "goods") }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="status"
				  title="支付状态"
				  min-width="120px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span class="orange-state" v-if="row.status == 0">待支付</span>
					<span class="blue-state" v-else-if="row.status == 1">支付成功</span>
					<span class="red-state" v-else-if="row.status == 2">支付失败</span>
				  	<span class="red-state" v-else-if="row.status == 3">订单关闭</span>
					<span class="red-state" v-else-if="row.status == 4">已退款</span>
				  </template>
				</vxe-table-column>
<!--				<vxe-table-column title="操作" min-width="160px" align="center">
				  <template v-slot="{ row }">
					<el-button
					  round
					  plain
					  class="table-btn"
					  type="primary"
					  size="small"
					  v-if="roleBtns.includes('payDetailInfo')"
					  @click="showDetail(row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
					<el-button
					  round
					  plain
					  type="danger"
					  class="table-btn"
					  size="small"
					  disabled
					  v-if="roleBtns.includes('refund')"
					  @click="refund(row)"
					>
					  <svg-icon icon-class="form-refund"></svg-icon> 退款
					</el-button>
				  </template>
				</vxe-table-column>-->
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="tablePage.currentPage"
				:page-size="tablePage.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tablePage.total"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="h100 pay-money bgc" v-else>
		<div class="money-detail">
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>支付流水号：</span>
			  <span>{{ msgObj.bizOrderNo }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>订单日期：</span>
			  <span>{{ msgObj.createDate }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>支付状态：</span>
			  <span v-if="msgObj.status == 0">待支付</span>
			  <span v-else-if="msgObj.status == 1" class="green">支付成功</span>
			  <span v-else-if="msgObj.status == 2" class="red">支付失败</span>
			  <span v-else-if="msgObj.status == 3" class="green">订单关闭</span>
			  <span v-else-if="msgObj.status == 4" class="red">已退款</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>支付会员： </span>
			  <span>{{ msgObj.payerId }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>订单金额： </span>
			  <span>{{ msgObj.amount }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>手续费： </span>
			  <span>{{ msgObj.serviceFee }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>行业代码： </span>
			  <span>{{ msgObj.industryCode }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>行业名称： </span>
			  <span>{{ msgObj.industryName }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>订单来源： </span>
			  <span>{{ dealType(msgObj.sysNo, "goods") }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>商户系统商品编号： </span>
			  <span>{{ msgObj.bizGoodsNo }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>账户集编号： </span>
			  <span>{{ msgObj.accountSetNo }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>访问中端类型：</span>
			  <span v-if="msgObj.source == 1">移动端</span>
			  <span v-else-if="msgObj.source == 2">PC端</span>
			  <span v-else>-</span>
			</el-col>
		  </el-row>
		  <el-row class="mb10" :gutter="20">
			<el-col :span="8" class="text-overflow">
			  <span>摘要： </span>
			  <span>{{ msgObj.summary }}</span>
			</el-col>
			<el-col :span="8" class="text-overflow">
			  <span>通商云订单号： </span>
			  <span>{{ msgObj.orderNo }}</span>
			</el-col>
		  </el-row>
		  <el-row class="mb30">
			<el-col :span="8" class="text-overflow">
			  <span>支付方式： </span>
			  <span>{{ msgObj.payWayName }}</span>
			</el-col>
		  </el-row>
		  <el-divider content-position="left">分账信息-付款对象</el-divider>
		  <vxe-table
			border
			:data="payData"
			size="small"
			highlight-current-row
			highlight-hover-row
			show-overflow="tooltip"
			show-header-overflow="tooltip"
		  >
			<vxe-table-column
			  field="recieverId"
			  title="会员ID"
			  width="180"
			  align="center"
			></vxe-table-column>
			<vxe-table-column field="memberType" title="会员类型" align="center">
			  <template v-slot="{ row }">
				<span v-if="row.memberType == 1">平台会员</span>
				<span v-else-if="row.memberType == 2">企业会员</span>
				<span v-else-if="row.memberType == 3">个人会员</span>
				<span v-else>-</span>
			  </template>
			</vxe-table-column>
			<vxe-table-column
			  field="sname"
			  title="企业名称"
			  header-align="center"
			></vxe-table-column>
			<vxe-table-column
			  field="cardNo"
			  title="证件号"
			  header-align="center"
			></vxe-table-column>
			<vxe-table-column
			  field="accountSetNo"
			  title="托管账户集"
			  header-align="center"
			></vxe-table-column>
			<vxe-table-column
			  field="amount"
			  title="金额"
			  header-align="center"
			  align="right"
			  width="120"
			>
			  <template v-slot="{ row }">
				{{ row.amount.toFixed(2) }}
			  </template>
			</vxe-table-column>
			<vxe-table-column
			  field=""
			  title="手续费"
			  header-align="center"
			  align="right"
			  width="120"
			>
			  <template>0</template>
			</vxe-table-column>
			<vxe-table-column
			  field="remark"
			  title="备注"
			  header-align="center"
			></vxe-table-column>
		  </vxe-table>
		</div>
		<div class="footer text-center hidden">
		  <el-button class="btn cancel-btn" @click="goBack()">返回</el-button>
		</div>
	  </div>
	</div>
  </template>
<script>
import { payGetDicts } from "api/modules/dict";
import {
	getPayBillDetail,
	selectPayDetailAll,
} from "api/modules/paymentSettlement";
import { mapState } from "vuex";

export default {
	name: 'Pay-money',
	props: {},
	data() {
		return {
			searchForm: {
				bizOrderNo: '', //流水号
				sysNo: '', //订单来源
				payerId: '', //会员id
				status: '', //支付状态
				payType: '', //支付方式
				orderStarDate: '', //订单开始时间
				orderEndDate: '', //订单结束时间
				minAmount: '', //订单金额最小
				maxAmount: '', //订单金额最大
			},
			tableData: [],
			tablePage: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			payData: [],
			msgObj: {},
			payType: [],
			goodsType: [],

			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('payMoney')) {
				this.searchForm = JSON.parse(this.$getSessionItem('payMoney'))
				this.tablePage.currentPage = JSON.parse(
					this.$getSessionItem('payMoney')
				).currentPage
				this.tablePage.pageSize = JSON.parse(
					this.$getSessionItem('payMoney')
				).pageSize
				this.$removeSessionItem('payMoney')
			}
		}

		this.selectPayDetailAll()
		this.msgObj.bizOrderNo ? '' : this.goBack()
		this.getDict('1008')
		this.getDict('1016')
	},
	methods: {
		// 获取所有的流水数据
		selectPayDetailAll() {
			let params = Object.assign({}, this.searchForm)
			params.current = this.tablePage.currentPage
			params.size = this.tablePage.pageSize
			selectPayDetailAll(params).then((d) => {
				if (d.operationCode == 1) {
					this.tableData = d.data.records
					this.tablePage.total = parseInt(d.data.total)
				}
			})
		},

		// 搜索
		searchResult() {
			let min = this.searchForm.minAmount
			let max = this.searchForm.maxAmount
			min != '' ? (this.searchForm.minAmount = parseFloat(min)) : ''
			max != '' ? (this.searchForm.maxAmount = parseFloat(max)) : ''
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.selectPayDetailAll()
		},

		// 重置
		reset() {
			this.tablePage.currentPage = 1
			this.tablePage.pageSize = 10
			this.searchForm.orderEndDate = ''
			this.searchForm.orderStarDate = ''
			this.searchForm.maxAmount = ''
			this.searchForm.minAmount = ''
			this.searchForm.bizOrderNo = ''
			this.searchForm.payerId = ''
			this.searchForm.payType = ''
			this.searchForm.sysNo = ''
			this.searchForm.status = ''
			this.selectPayDetailAll()
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tablePage.pageSize = size
			this.selectPayDetailAll()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tablePage.currentPage = cur
			this.selectPayDetailAll()
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 查看详情
		showDetail(data) {
			let params = Object.assign({}, this.searchForm)
			params.pageSize = this.tablePage.pageSize
			params.currentPage = this.tablePage.currentPage

			// 存值
			this.$setSessionItem('payMoney', JSON.stringify(this.searchForm))

			this.$router.push({
				path: '/pay-money',
				query: {
					type: 'money-detail',
				},
			})
			getPayBillDetail({
				id: data.id,
			}).then((res) => {
				if (res.operationCode == 1) {
					this.msgObj = res.data.operatePayBillInfo
					this.payData = res.data.operateOrderDecList
				}
			})
		},

		// 退款
		refund(data) {
			alert('refund')
		},

		// 返回
		goBack() {
			this.$router.push({ path: '/pay-money' })
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.orderEndDate
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(
							time,
							endTime,
							true
						)
					} else {
						return time.getTime() > Date.now()
					}
				},
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.orderStarDate
					if (startTime) {
						let nowTime = Date.now()
						return bmElementTimeOptins.limitDateInRange(
							time,
							startTime,
							nowTime,
							true
						)
					} else {
						return time.getTime() > Date.now()
					}
				},
			}
		},

		// 获取支付方式和商品类型码表
		getDict(type) {
			payGetDicts({
				parentValue: type,
			}).then((d) => {
				if (d.operationCode == 1) {
					type == '1008'
						? (this.payType = d.data)
						: (this.goodsType = d.data)
				}
			})
		},

		// 处理类型
		dealType(data, type) {
			let msg = ''
			if (type == 'goods') {
				let obj = this.goodsType.find((x) => x.value == data)
				obj ? (msg = obj.sname) : ''
			} else {
				let obj = this.payType.find((x) => x.value == data)
				obj ? (msg = obj.sname) : ''
			}
			return msg
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', {
			isBack: (state) => state.isBack,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
	},
}
</script>
<style lang="less" scoped>
.pay-money {
	//.el-form {
	//	border-bottom: 1px solid #2671cc;
	//}
	.btn-style {
		width: 80px;
		height: 32px;
	}
	.btn-blue {
		background-color: #2671cc !important;
		color: #fff;
	}
	.operation-header {
		display: block;
		line-height: 40px;

		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.number {
				padding-left: 10px;
				border-left: 4px solid #2671cc;
				height: 30px;
				line-height: 30px;

				span {
					color: #2671cc;
					font-size: 18px;
				}
			}
		}
	}
	.operation-container {
		height: calc(~'100% - 52px') !important;
	}
	/deep/ .vxe-cell--title {
		color: #202020;
		font-size: 14px;
		font-weight: normal;
	}
	.money-detail {
		padding: 30px 50px 0 50px;
		height: calc(~'100% - 50px');
		span {
			font-size: 14px;
		}
	}
	.mb10 {
		margin-bottom: 10px !important;
	}
	.green {
		color: green;
	}
	.red {
		color: red;
	}
	.greens,
	.reds,
	.yellows {
		// padding-left: 20px;
	}
	.greens::before {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: #72aa2c;
		box-shadow: 0px 0px 4px 0px #72aa2c;
	}
	.reds::before {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: red;
		box-shadow: 0px 0px 4px 0px red;
	}
	.yellows::before {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: orange;
		box-shadow: 0px 0px 4px 0px orange;
	}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
	  .pd5{
		padding: 0 5px;
	  }
}
.bgc {
	background-color: #fff;
}
</style>
